export const VUE_APP_I18N_LOCALE = 'ru';

export const DOMAIN_TITLE = 'Capusta.space';
export const DOCS_URL = 'https://docs.capusta.space';
export const HELP_URL = 'https://help.capusta.space';

export const API_URL = 'https://api.capusta.space/v1/cabinet';
export const PAYMANT_URL = 'https://get.capusta.space';
export const LANDING_URL = 'https://capusta.space';
export const MARKETPLACE_URL = 'https://maker.capusta.space';

export const TELEGRAM_BOT_LINK = 'tg://resolve?domain=capusta_go_bot';
export const TELEGRAM_OPEN = 't.me/capusta_go_bot';

export const SOCKET_INIT = 'wss://api.capusta.space/init?access_token=';
export const TWO_FACTOR_AUTH_SOCKET = 'wss://api.capusta.space/two-factor-auth?access_token=';

export const MYID_CLIENT_ID = 'sourcetopay_web-S12eeVF6FuaQnjfDFREUCyqiw44mpBCX962iC6uk';
export const MYID_REDIRECT_URI = 'https://capusta.space/identification/myid';
export const MYID_AUTH_URI = 'https://myid.uz/api/v1/oauth2/authorization';
